/**
 * The words the Campaigns screen's panels say about the screen itself (the one-screen
 * layout, audits/2026-10-29/gui/principles.md §3) — where things open, nothing about X.
 * Everything else the screen says stays in `campaign-copy.ts` and the modules it borrows
 * from, as it stood.
 *
 * 🔴 The two empty-panel sentences name the row's own buttons, `OPEN_CARD` and the Line
 * items button, because those buttons stay: the panels are where they open now, beside
 * the list rather than under it, and the copy that names them (`LINE_ITEMS_HERE`,
 * `WRITES_HERE`, `PAUSE_FIRST`) stays true because the buttons and the sections do.
 */
import { OPEN_CARD } from "./campaign-card-copy.ts";

export const CAMPAIGNS_PANEL = "Campaigns";
export const CARD_PANEL = "Campaign card";
export const LINE_ITEMS_PANEL = "Line items";
export const NEW_CAMPAIGN_PANEL = "New campaign";

export const CARD_PANEL_EMPTY = `Press ${OPEN_CARD} on a campaign's row to open it here.`;
export const LINE_ITEMS_PANEL_EMPTY =
	"Press Line items on a campaign's row to open its line items here.";

/** The toggle in the screen's top line, beside Create ad. */
export const NEW_CAMPAIGN = "New campaign";
export const HIDE_NEW_CAMPAIGN = "Hide new campaign";

/**
 * Campaign rows per page in the list panel. Five fit the list's half of the screen with
 * the row's Card and Edit buttons under each name — a reading of the layout, not a
 * measurement: the 800px fit is not measured (twads PR body names how to measure it).
 */
export const CAMPAIGNS_PAGE_SIZE = 5;

/**
 * The Start confirmation's own words (PR 2). The question in it is `enablePrompt`
 * (`campaign-copy.ts`), as it stands, and the second button is `CANCEL`. Bare «Start»,
 * because the window names its one campaign (B2, -3d's decision of 2026-10-29).
 */
export const START = "Start";
export const startTitle = (id: string) => `Start · ${id}`;
